import { useFormikContext } from "formik";
import { FC } from "react";
import { useLocale } from "@/contexts/localeContext";
import { TranslationKeys } from "@/contexts/TranslationKeys";
import { Button } from "@/components/button/Button";

interface SummaryStepProps {
    onBack: (event: any) => void;
}

const SummaryStep: FC<SummaryStepProps> = ({ onBack }) => {
    const { values, submitForm } = useFormikContext<any>();
    const { translate } = useLocale();

    return  <div className="flex flex-col pt-3 pr-3 h-full relative">
        <div className="flex flex-row">
            <div className="flex flex-col flex-1 overflow-y-auto" style={{ maxHeight: "392px" }}>
                <span className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.summary)}:</span>
                <span className="p-1 text-xs text-gray-600"> {translate.byKey(TranslationKeys.name)}:<span className="text-sm text-black">{values.selectedAction?.nameOriginal}</span></span>
                <span className="p-1 text-xs text-gray-600"> {translate.byKey(TranslationKeys.type)}:<span className="text-sm text-black">{values.selectedAction?.type}</span></span>
            </div>
        </div>
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3">
            <div className="flex flex-row mt-4">
                <button
                    className="secondary secondary-inverse py-1 px-5"
                    type="button"
                    onClick={onBack}> {translate.byKey(TranslationKeys.back)}
                </button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <Button
                    variant="submit"
                    shape="pill"
                    id="submitBioEventActionId"
                    type="button"
                    onClick={submitForm}>
                    {translate.byKey(TranslationKeys.confirm)}
                </Button>
            </div>
        </div>
    </div>
};

export default SummaryStep;